import { render, staticRenderFns } from "./riskdrawertwo.vue?vue&type=template&id=363098a6&scoped=true&"
import script from "./riskdrawertwo.vue?vue&type=script&lang=js&"
export * from "./riskdrawertwo.vue?vue&type=script&lang=js&"
import style0 from "./riskdrawertwo.vue?vue&type=style&index=0&id=363098a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363098a6",
  null
  
)

export default component.exports